module.exports = __webpack_public_path__ + "static/img/logo-2.d5b870aa.png";